import React from "react";
import { FaInstagram, FaFacebookF, FaLinkedinIn, FaYoutube, FaTwitter, FaGoogle } from "react-icons/fa";

import company from "../../../data/company";
import Reveal from "../../../components/Reveal";

const ICONS = [
  { Icon: FaInstagram, href: company.social.instagram, label: "Instagram" },
  { Icon: FaFacebookF, href: company.social.facebook, label: "Facebook" },
  { Icon: FaLinkedinIn, href: company.social.linkedin, label: "LinkedIn" },
  { Icon: FaYoutube, href: company.social.youtube, label: "YouTube" },
  { Icon: FaTwitter, href: company.social.twitter, label: "Twitter" },
  { Icon: FaGoogle, href: company.social.google, label: "Google" },
];

export default function SocialLinks() {
  return (
    <div className="flex flex-col items-center px-6">
      <Reveal>
        <p className="text-center font-accent font-medium text-maroon-500 text-xs sm:text-sm tracking-[0.35em] uppercase mb-8">
          Follow Us
        </p>
      </Reveal>
      <div className="flex flex-wrap items-center justify-center gap-4 sm:gap-8">
        {ICONS.map(({ Icon, href, label }, i) => (
          <Reveal key={label} delay={i * 120}>
            <a
              href={href}
              aria-label={label}
              className="flex items-center justify-center h-12 w-12 sm:h-14 sm:w-14 rounded-full border border-gold-500 text-gold-500 bg-maroon-800 hover:bg-gold-500 hover:text-maroon-900 hover:scale-110 transition-all duration-500 shadow-md"
            >
              <Icon className="h-5 w-5" />
            </a>
          </Reveal>
        ))}
      </div>
      {/* Quote */}
      <Reveal delay={450}>
  <blockquote className="mt-12 max-w-3xl text-center">
    <p className="font-body italic text-maroon-700 text-base leading-relaxed">
      “Every weave reflects dedication.<br />
      Every texture tells a story.<br />
      Every fabric carries the promise of uncompromising quality.”
    </p>
  </blockquote>
</Reveal>
    </div>
  );
}
